<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { api, messageFrom } from '../api'
import { formatDate } from '../format'
import type { PublicQuestionLog } from '../types'

const emit = defineEmits<{ navigate: [path: string] }>()
const questions = ref<PublicQuestionLog[]>([])
const loading = ref(true)
const error = ref('')

function cost(item: PublicQuestionLog): string {
  if (item.cacheHit) return '$0 · из кеша'
  if (item.costUsd === null) return 'стоимость не передана провайдером'
  if (item.costUsd === 0) return '$0'
  return `$${item.costUsd.toFixed(item.costUsd < 0.001 ? 6 : 4)}`
}

async function load(): Promise<void> {
  loading.value = true
  error.value = ''
  try {
    questions.value = (await api<{ questions: PublicQuestionLog[] }>('/api/admin/questions')).questions
  } catch (reason) {
    error.value = messageFrom(reason)
  } finally {
    loading.value = false
  }
}

onMounted(load)
</script>

<template>
  <main class="page page--questions">
    <button class="back-link" type="button" @click="emit('navigate', '/admin')">← Все папки</button>
    <header class="page-heading">
      <p class="eyebrow">Публичная часть</p>
      <h1>Последние вопросы</h1>
    </header>

    <p v-if="loading" class="quiet-message">Загружаем журнал…</p>
    <p v-else-if="error" class="field-error" role="alert">{{ error }}</p>
    <p v-else-if="!questions.length" class="empty-state">Вопросов пока не было.</p>
    <section v-else class="question-log">
      <article v-for="item in questions" :key="item.id" class="question-log-item">
        <div class="question-log-item__meta">
          <strong>{{ item.speakerName }}</strong>
          <span>{{ formatDate(item.createdAt) }}</span>
        </div>
        <p class="question-log-item__question">{{ item.question }}</p>
        <p class="question-log-item__answer">{{ item.answer }}</p>
        <p class="question-log-item__model">
          {{ item.modelLabel }} · {{ cost(item) }}
          <template v-if="item.telegramUserId"> · Telegram ID {{ item.telegramUserId }}</template>
        </p>
      </article>
    </section>
  </main>
</template>
